<section>
  <div id="oao-additional-question">
    <div *ngFor="let field of applicationCustomFields; index as Index"
      class="bl-display--flex bl-margin-bottom--8 bl-margin-top--4">
      <span class="bl-col-6 bl-padding-x--0">
        {{field.fieldLabel}} 
      </span>
      <span class="bl-col-5 bl-padding-left--24" [innerHTML]="displayValue(field.fieldValue)">
        
      </span>
    </div>
  </div>
</section>